var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading_animation"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.label)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/LoadingAnimation.vue